import { WebRequest, RequestType } from "./web_request"

export class TokenRequest extends WebRequest{
    host: string;
    name: String;
    readonly type: RequestType.token
}


